import {matchPath} from "react-router-dom";
import {ROUTES} from "../components/AppRouter/AppRouter";

export const formatNumberPrecision = (number, precision = 4, round = false) => {
	if (typeof number !== 'number' || isNaN(number)) {
		return '-/-';
	}
	if (round) {
		return Number(number.toFixed(precision));
	} else {
		const stringNumber = number.toString();
		const decimalIndex = stringNumber.indexOf('.') + 1;
		if (decimalIndex === 0) {
			return number.toString();
		}
		const endIndex = Math.min(decimalIndex + precision, stringNumber.length);
		return Number(stringNumber.substring(0, endIndex));
	}
}


export const combineClasses = (...classNames) => {
	return classNames.filter(Boolean).join(' ');
}

export const findRouteKeyByPath = (pathname) => {
	for (const route of Object.values(ROUTES)) {
		const match = matchPath({ path: route.path }, pathname);
		if (match) {
			return route.key;
		}
	}
	return null;
};


export const handleFileToBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
};
